import localforage from 'localforage';

// Configure localforage
localforage.config({
  name: 'smart-deal-switcher',
  storeName: 'app_store'
});

export const storage = {
  async getItem<T>(key: string): Promise<T | null> {
    try {
      return await localforage.getItem<T>(key);
    } catch (error) {
      console.error('Error reading from storage:', error);
      return null;
    }
  },

  async setItem<T>(key: string, value: T): Promise<void> {
    try {
      await localforage.setItem(key, value);
    } catch (error) {
      console.error('Error writing to storage:', error);
    }
  },

  async removeItem(key: string): Promise<void> {
    try {
      await localforage.removeItem(key);
    } catch (error) {
      console.error('Error removing from storage:', error);
    }
  }
};